import { Link } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export function JoinLoading() {
  return (
    <div className="flex flex-col items-center gap-4 py-8">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
      <p className="text-muted-foreground text-sm">Vérification du lien d'invitation...</p>
    </div>
  );
}

export function JoinInvalid({ reason }: { reason: string }) {
  return (
    <div className="flex flex-col items-center gap-4 py-6 text-center">
      <div className="w-14 h-14 rounded-full bg-destructive/10 flex items-center justify-center">
        <XCircle className="w-7 h-7 text-destructive" />
      </div>
      <div>
        <h3 className="font-semibold text-lg">Lien invalide</h3>
        <p className="text-muted-foreground text-sm mt-2">{reason}</p>
      </div>
      <Link to="/auth" className="text-primary text-sm hover:underline">
        Retour à la connexion
      </Link>
    </div>
  );
}

export function JoinDone() {
  return (
    <div className="flex flex-col items-center gap-4 py-6 text-center">
      <div className="w-14 h-14 rounded-full bg-success/10 flex items-center justify-center">
        <CheckCircle2 className="w-7 h-7 text-success" />
      </div>
      <div>
        <h3 className="font-semibold text-lg">Bienvenue !</h3>
        <p className="text-muted-foreground text-sm mt-2">
          Votre compte a été activé. Redirection en cours...
        </p>
      </div>
      <Loader2 className="w-5 h-5 animate-spin text-primary" />
    </div>
  );
}
